import React from 'react';
import './PrivacyPolicy.css';

function FunelogPrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>

      <p>
        This privacy policy applies to the Funelog (フネログ) app
        (hereby referred to as "Application") for mobile devices that was
        created by Takuma Kano (hereby referred to as "Service Provider") as a
        free service. This service is intended for use "AS IS".
      </p>

      <h2>Information Collection and Use</h2>
      <p>
        The Application collects information when you use it. This information
        may include:
      </p>

      <ul>
        <li>Images captured using the device camera</li>
        <li>Data extracted from images such as race and betting information</li>
        <li>Your device's Internet Protocol address (e.g. IP address)</li>
        <li>The time and date of your use of the Application</li>
        <li>The time spent on the Application</li>
        <li>The operating system you use on your mobile device</li>
      </ul>

      <p>
        The Application uses the device camera to capture images of boat race
        tickets. These images are used for OCR processing to extract race and
        betting information.
      </p>

      <p>
        Captured images and extracted data may be stored locally on the user's
        device. The Application does not use this data to identify individuals.
      </p>

      <p>
        In some cases, data may be processed on external servers for analysis
        purposes.
      </p>

      <p>
        The Application does not gather precise information about the location
        of your mobile device.
      </p>

      <h2>Third Party Access</h2>
      <p>
        Only aggregated, anonymized data may be periodically transmitted to
        external services to aid the Service Provider in improving the
        Application and their service. The Service Provider may share your
        information with third parties only in the ways that are described in
        this privacy statement.
      </p>

      <p>
        The Application may utilize third-party services with their own Privacy
        Policies. Below are links to the Privacy Policy of third-party service
        providers that may be used by the Application:
      </p>

      <ul>
        <li>
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Play Services
          </a>
        </li>
      </ul>

      <h2>Opt-Out Rights</h2>
      <p>
        You can stop all collection of information by the Application easily by
        uninstalling it. You may use the standard uninstall processes available
        as part of your mobile device or via the application marketplace.
      </p>

      <h2>Data Retention Policy</h2>
      <p>
        The Service Provider will retain user-provided data for as long as you
        use the Application and for a reasonable time thereafter. If you would
        like your data to be deleted, please contact aideagoesup@gmail.com.
      </p>

      <h2>Children</h2>
      <p>
        The Service Provider does not use the Application to knowingly solicit
        data from or market to children under the age of 13.
      </p>

      <h2>Security</h2>
      <p>
        The Service Provider is concerned about safeguarding the confidentiality
        of your information. Reasonable physical, electronic, and procedural
        safeguards are used to protect information processed and maintained.
      </p>

      <h2>Changes</h2>
      <p>
        This Privacy Policy may be updated from time to time. The Service
        Provider will notify you of any changes by updating this page. This
        policy is effective as of 2026-05-01.
      </p>

      <h2>Your Consent</h2>
      <p>
        By using the Application, you are consenting to the processing of your
        information as set forth in this Privacy Policy.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact the
        Service Provider at aideagoesup@gmail.com.
      </p>
    </div>
  );
}

export default FunelogPrivacyPolicy;